<script>
	import{Heaven} from '../../../public/assets/urls';
</script>

<div class="fog_container">
	<img class="heaven" src={Heaven} alt=""/>
</div>